/**
 * actualites.js
 */

// Import
import "./actualites.scss";
import $ from 'jquery';

$(document).ready(function() {

});